import * as Types from "./operations";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;

export const FetchActionsDocument = gql`
  query fetchActions {
    fetchActions {
      code
      name
    }
  }
`;

/**
 * __useFetchActionsQuery__
 *
 * To run a query within a React component, call `useFetchActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FetchActionsQuery,
    Types.FetchActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FetchActionsQuery,
    Types.FetchActionsQueryVariables
  >(FetchActionsDocument, options);
}
export function useFetchActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FetchActionsQuery,
    Types.FetchActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FetchActionsQuery,
    Types.FetchActionsQueryVariables
  >(FetchActionsDocument, options);
}
export type FetchActionsQueryHookResult = ReturnType<
  typeof useFetchActionsQuery
>;
export type FetchActionsLazyQueryHookResult = ReturnType<
  typeof useFetchActionsLazyQuery
>;
export type FetchActionsQueryResult = Apollo.QueryResult<
  Types.FetchActionsQuery,
  Types.FetchActionsQueryVariables
>;
export const UploadCompanyLogoDocument = gql`
  mutation uploadCompanyLogo($file: Upload!, $companyId: String!) {
    uploadCompanyLogo(file: $file, companyId: $companyId)
  }
`;
export type UploadCompanyLogoMutationFn = Apollo.MutationFunction<
  Types.UploadCompanyLogoMutation,
  Types.UploadCompanyLogoMutationVariables
>;

/**
 * __useUploadCompanyLogoMutation__
 *
 * To run a mutation, you first call `useUploadCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCompanyLogoMutation, { data, loading, error }] = useUploadCompanyLogoMutation({
 *   variables: {
 *      file: // value for 'file'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUploadCompanyLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UploadCompanyLogoMutation,
    Types.UploadCompanyLogoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UploadCompanyLogoMutation,
    Types.UploadCompanyLogoMutationVariables
  >(UploadCompanyLogoDocument, options);
}
export type UploadCompanyLogoMutationHookResult = ReturnType<
  typeof useUploadCompanyLogoMutation
>;
export type UploadCompanyLogoMutationResult =
  Apollo.MutationResult<Types.UploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationOptions = Apollo.BaseMutationOptions<
  Types.UploadCompanyLogoMutation,
  Types.UploadCompanyLogoMutationVariables
>;
export const FetchProfitCentersDocument = gql`
  query fetchProfitCenters {
    fetchProfitCenters {
      code
      name
    }
  }
`;

/**
 * __useFetchProfitCentersQuery__
 *
 * To run a query within a React component, call `useFetchProfitCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProfitCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProfitCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProfitCentersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FetchProfitCentersQuery,
    Types.FetchProfitCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FetchProfitCentersQuery,
    Types.FetchProfitCentersQueryVariables
  >(FetchProfitCentersDocument, options);
}
export function useFetchProfitCentersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FetchProfitCentersQuery,
    Types.FetchProfitCentersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FetchProfitCentersQuery,
    Types.FetchProfitCentersQueryVariables
  >(FetchProfitCentersDocument, options);
}
export type FetchProfitCentersQueryHookResult = ReturnType<
  typeof useFetchProfitCentersQuery
>;
export type FetchProfitCentersLazyQueryHookResult = ReturnType<
  typeof useFetchProfitCentersLazyQuery
>;
export type FetchProfitCentersQueryResult = Apollo.QueryResult<
  Types.FetchProfitCentersQuery,
  Types.FetchProfitCentersQueryVariables
>;
export const UploadDeliveryNoteDocumentDocument = gql`
  mutation uploadDeliveryNoteDocument(
    $file: Upload!
    $deliveryNoteId: String!
    $type: String!
  ) {
    uploadDeliveryNoteDocument(
      file: $file
      deliveryNoteId: $deliveryNoteId
      type: $type
    )
  }
`;
export type UploadDeliveryNoteDocumentMutationFn = Apollo.MutationFunction<
  Types.UploadDeliveryNoteDocumentMutation,
  Types.UploadDeliveryNoteDocumentMutationVariables
>;

/**
 * __useUploadDeliveryNoteDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDeliveryNoteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDeliveryNoteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDeliveryNoteDocumentMutation, { data, loading, error }] = useUploadDeliveryNoteDocumentMutation({
 *   variables: {
 *      file: // value for 'file'
 *      deliveryNoteId: // value for 'deliveryNoteId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUploadDeliveryNoteDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UploadDeliveryNoteDocumentMutation,
    Types.UploadDeliveryNoteDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UploadDeliveryNoteDocumentMutation,
    Types.UploadDeliveryNoteDocumentMutationVariables
  >(UploadDeliveryNoteDocumentDocument, options);
}
export type UploadDeliveryNoteDocumentMutationHookResult = ReturnType<
  typeof useUploadDeliveryNoteDocumentMutation
>;
export type UploadDeliveryNoteDocumentMutationResult =
  Apollo.MutationResult<Types.UploadDeliveryNoteDocumentMutation>;
export type UploadDeliveryNoteDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UploadDeliveryNoteDocumentMutation,
    Types.UploadDeliveryNoteDocumentMutationVariables
  >;
export const TestMutationDocument = gql`
  mutation testMutation {
    testMutation
  }
`;
export type TestMutationMutationFn = Apollo.MutationFunction<
  Types.TestMutationMutation,
  Types.TestMutationMutationVariables
>;

/**
 * __useTestMutationMutation__
 *
 * To run a mutation, you first call `useTestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testMutationMutation, { data, loading, error }] = useTestMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.TestMutationMutation,
    Types.TestMutationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.TestMutationMutation,
    Types.TestMutationMutationVariables
  >(TestMutationDocument, options);
}
export type TestMutationMutationHookResult = ReturnType<
  typeof useTestMutationMutation
>;
export type TestMutationMutationResult =
  Apollo.MutationResult<Types.TestMutationMutation>;
export type TestMutationMutationOptions = Apollo.BaseMutationOptions<
  Types.TestMutationMutation,
  Types.TestMutationMutationVariables
>;
export const TestQueryDocument = gql`
  query testQuery {
    testQuery
  }
`;

/**
 * __useTestQueryQuery__
 *
 * To run a query within a React component, call `useTestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.TestQueryQuery,
    Types.TestQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.TestQueryQuery, Types.TestQueryQueryVariables>(
    TestQueryDocument,
    options
  );
}
export function useTestQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.TestQueryQuery,
    Types.TestQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.TestQueryQuery,
    Types.TestQueryQueryVariables
  >(TestQueryDocument, options);
}
export type TestQueryQueryHookResult = ReturnType<typeof useTestQueryQuery>;
export type TestQueryLazyQueryHookResult = ReturnType<
  typeof useTestQueryLazyQuery
>;
export type TestQueryQueryResult = Apollo.QueryResult<
  Types.TestQueryQuery,
  Types.TestQueryQueryVariables
>;
